export default function StopPropagationDirective() {
	return {
		restrict: 'A',
		link: function(scope, element, attr) {
			if (attr && attr.stopPropagation) {
				element.bind(attr.stopPropagation, function(e) {
					e.stopPropagation();
				});
			}
		}
	};
}
